import useOutsideClick from 'hooks/useOutsideClick';
import { useCallback, useEffect, useRef, useState } from 'react';
import CheckBox from 'style-guide/CheckBox';
import { Input } from 'style-guide/Input';
import Text from 'style-guide/Typography/Text';

const LinkInput = ({ editor, linkModalVisible, setLinkModalVisible, isFixedMenu }) => {
  const [linkValue, setLinkValue] = useState('');
  const ref = useRef(null);
  const excludedRef = useRef(null);

  const [isLinkTargetChecked, setIsLinkTargetChecked] = useState(false);

  const isLinkActive = editor?.isActive('link');
  const hasLinkValue = editor?.getAttributes('link');

  const onLinkClose = useCallback(() => {
    setLinkModalVisible(false);
    setIsLinkTargetChecked(false);
    !isFixedMenu ? setLinkValue('') : null;
  }, [isFixedMenu, setLinkModalVisible]);

  useEffect(() => {
    if (linkModalVisible) {
      editor?.on('selectionUpdate', onLinkClose);
    }

    return () => {
      if (linkModalVisible) {
        editor?.off('selectionUpdate', onLinkClose);
      }
    };
  }, [editor, linkModalVisible, onLinkClose]);

  const onInsertLinkSuccess = (href) => {
    setLinkModalVisible(false);
    if (href === null) {
      return;
    }

    if (href === '') {
      editor?.chain().focus().extendMarkRange('link').unsetLink().run();
      return;
    }
    editor
      ?.chain()
      ?.toggleLink?.({ href, target: isLinkTargetChecked ? '_blank' : '_self' })
      .run();
    editor?.chain().run();
  };

  useEffect(() => {
    setIsLinkTargetChecked(hasLinkValue?.target === '_blank');
    setLinkValue(isLinkActive ? hasLinkValue?.href : '');
  }, [hasLinkValue?.href, hasLinkValue?.target, isLinkActive]);

  useOutsideClick({
    ref,
    excludedRef,
    cb: () => setLinkModalVisible(false),
  });

  return (
    <div ref={excludedRef} className='mt--12 editor-link-section'>
      <div className='d-flex align-items-center'>
        <CheckBox
          checked={isLinkTargetChecked}
          onChange={(e) => {
            setIsLinkTargetChecked(e.target.checked);
            editor
              ?.chain()
              ?.toggleLink?.({ target: e.target.checked ? '_blank' : '_self' })
              .run();
          }}
        />
        <Text $variant={1} className='ml--8'>
          Open a new tab
        </Text>
      </div>
      <Input
        ref={ref}
        className='pt--4'
        value={linkValue}
        onChange={(e) => setLinkValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onInsertLinkSuccess(e.target.value, isLinkTargetChecked);
          }
        }}
      />
    </div>
  );
};

export default LinkInput;
